import flatten from 'lodash/flatten';

export const flattenChefs = allPresets =>
  flatten(allPresets.map(presetCategory => presetCategory[1]));
